export default __webpack_public_path__ + "static/media/minutia_logo.cf400398.svg";